import Content from '../content-interface'
import Validity from '../validity.entity';
import FeeRuleHistory from './fee-rules-history.entity';

export default class FeeUpdatedHistory implements Content {
  strategy: string;

  type: string;

  justification: string;

  observation: string;

  validity: Validity

  rules: FeeRuleHistory[]

  constructor(obj: any = {}) {
    this.strategy = obj.strategy || '';
    this.type = obj.type || '';
    this.justification = obj.justification || '';
    this.observation = obj.observation || '';
    this.validity = Validity.of(obj.validity) || {};
    this.rules = FeeRuleHistory.ofList(obj.rules) || [];
  }

  public static of(obj: any = {}): FeeUpdatedHistory {
    return new FeeUpdatedHistory(obj);
  }
}
